__turbopack_context__.v({
  "aligned": "CommonInner-module-scss-module__kN11Ra__aligned",
  "inner": "CommonInner-module-scss-module__kN11Ra__inner",
  "row": "CommonInner-module-scss-module__kN11Ra__row",
  "row_reverse": "CommonInner-module-scss-module__kN11Ra__row_reverse",
});
